import { useFormContext } from 'react-hook-form';

import { TextField } from '@components/form/fields';
import { Option } from '@components/ui/autocomplete/auto-complete-input';

import { SupplierSelectorCard } from '@/modules/purchase/shared';

import { TCreatePrePurchaseForm } from './create-pre-purchase.schema';

export const SupplierSelector = () => {
    const { setValue } = useFormContext<TCreatePrePurchaseForm>();

    const handleSupplierChange = (value: Option) => {
        setValue('supplier_id', value.value);
        setValue('supplier_name', value.label);
    };

    return (
        <SupplierSelectorCard onValueChange={handleSupplierChange}>
            <TextField<TCreatePrePurchaseForm>
                label="Note"
                name="note"
                placeholder="Enter note (optional)"
            />
        </SupplierSelectorCard>
    );
};

SupplierSelector.displayName = 'SupplierSelector';
